import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AccessRequestSettingsPageLoader } from '@confluence/access-requests/entry-points/AccessRequestSettingsPageLoader.ts';
import { AdminSecurityPageWrapper } from '@confluence/site-permissions/entry-points/AdminSecurityPageWrapper.ts';

const i18n = defineMessages({
	pageTitle: {
		id: 'access-requests.admin-controls.settings-page.route-title.non-final',
		defaultMessage: 'Access Request',
		description: 'Document title for the Access Request Settings admin page',
	},
});

const AdminAccessRequestsRouteComponent = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const pageTitle = formatMessage(i18n.pageTitle);

	return (
		<AdminSecurityPageWrapper documentTitle={pageTitle}>
			<AccessRequestSettingsPageLoader />
		</AdminSecurityPageWrapper>
	);
};

AdminAccessRequestsRouteComponent.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'productAdminAccessRequestsSettingsScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID as string,
	MainLayout: {
		navView: ADMIN_HOME_ID as string,
	},
});

export const AdminAccessRequestsRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: { screenEvent: { name: string } };
		sideNavigationId: string;
		MainLayout: { navView: string };
	};
} = AdminAccessRequestsRouteComponent;
